import { V_FORM_ENUM } from '@/CommonDP/VForm/utils';

// 下拉数据 -PLUS
export const schema = {
  group: V_FORM_ENUM.custom,
  type: 'jy-select',
  icon: 'select-field',
  formItemFlag: true,
  label: '数据模型',
  component: require('./index.vue').default,
  events() {
    return {
      onSqlQuery: ['data']
    };
  },
  props() {
    return {
      dsEnabled: () => import('./setting.vue')
    };
  },
  options: {
    name: '',
    label: '',
    labelAlign: '',
    defaultValue: '',
    placeholder: '',
    columnWidth: '200px',
    size: '',
    labelWidth: null,
    labelHidden: false,
    labelWrap: false, // 自动换行
    disabled: false,
    hidden: false,
    clearable: true,
    filterable: false,
    // remote: false,
    // automaticDropdown: false, // 自动下拉
    multiple2: false,
    multipleLimit: 0,
    required: false,
    requiredHint: ' ',
    validation: '',
    validationHint: '',
    // -----------
    dsEnabled: false, // 是否使用数据源数据
    dsName: '',
    assignData: [],
    dsTriggerFields: [],
    columnField: [], // 列表弹框 字段 和顺序
    filterField: [],
    // --------
    // 搜索sql
    exprGroupList: [],
    exprJoinOp: 'and',
    // -------------------
    customClass: '', // 自定义css类名
    tableId: '',
    titleField: '',
    valueField: '',
    defaultFirst: false,
    // -------------------
    onCreated: '',
    onMounted: '',
    // onRemoteQuery: '',
    onChange: '',
    onInitAndUpdate: '',
    onFocus: '',
    onBlur: '',
    onValidate: '',
    onSqlQuery: ''
  },
  setColumns({
    tableId: tableName,
    exprJoinOp,
    exprGroupList }) {
    return {
      tableName,
      exprJoinOp,
      exprGroupList
    };
  }
};
